// UserAllocPermit.js
// import React, {useEffect, useState, useRef} from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import {
    DialogContent, DialogActions, Button, Grid
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { AppObject, AppStyle, AppWord } from '../../value/AppConst';
import { useReactiveVar } from '@apollo/client';
import { authTableTreeRepo } from '../../value/AppModel';
import { VzmPrint } from '../../common/VzmStyled';
import DraggableViewer from '../../common/DraggableViewer';
import VzmCheckbox from '../../common/VzmCheckbox';
import VzmTextField from '../../common/VzmTextField';
import { UserAllocDictionary } from './UserAllocDict';
import { useAuthorizationCheck } from '../../api/app-hook';
import { useEffect, useState } from 'react';
import InputUtil from '../../value/InputUtil';
import ValueMisc from '../../value/ValueMisc';

// background color in gradient style (light gray to white, then light gray)
const ViewContainer = styled(Box)({
    marginTop: 10
});

const InputMap = UserAllocDictionary.inputMap;
const PermitMap = UserAllocDictionary.permitInputMap;
/**
 * (USER_ALLOC) 승인요청에 대한 허용/불허 결정 Dialog
 * Using React with MUI5
 * Project: NewTOP for cloud
 * 2024-09-23 11:31:54 using DbdbTap
 */
export default function UserAllocPermit({
    open,
    item, // always not null
    onRequestPermit,
    onClose
}) {
    const [input, setInput] = useState({...AppObject.emptyInputData});
    const authTableTree = useReactiveVar(authTableTreeRepo);
    const checkAuth = useAuthorizationCheck();

    useEffect(()=>{
        if(open && item) {
            const inputSet = {...AppObject.emptyInputData};
            inputSet.data.userAllocSeq = item.userAllocSeq;
            inputSet.data.permit = item.allocFlag===UserAllocDictionary.value.Allow ? true : false;
            inputSet.data.note = item.note;

            setInput(inputSet);
        }
    }, [open, item]);

    if(!open || !item) return null;


    const onChangeValue = (id, value, error) => {
        const newInput = InputUtil.reflectData(input, id, value, error, PermitMap, true);
        setInput(newInput);
    };

    const canPermit = checkAuth(authTableTree.tree.pr_user_alloc_permit);

    const onClickPermit = () => {
        const param = {
            userAllocSeq: item.userAllocSeq,
            permit: input.data.permit,
            note: input.data.note
        }
        onRequestPermit(param);
    };

    return(
        <DraggableViewer open={open} onClose={onClose} maxWidth='lg'
            startIcon={<AssignmentIndIcon fontSize={AppWord.LARGE} style={{color:'white', marginRight:15}}/>}
            title={`${item.userName} 요청 상세정보`}
            style={{backgroundColor: AppStyle.SecondaryRGB}}
        >
            <DialogContent>
                <ViewContainer>
                    <Grid container spacing={2}>
                        
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.userId.label} value={item.userId} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.userName.label} value={item.userName} />
                        </Grid>
                        <Grid item xs={4}></Grid>

                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.className.label} value={item.className} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.allDc.label} value={item.allDc?'전체':'소속DC구분'} />
                        </Grid>
                        <Grid item xs={4}>
                            {
                                ValueMisc.isTruckCompanyClassId(item.authClassId)
                                ?
                                <VzmPrint label={InputMap.comName.label} value={item.comName} />
                                :
                                ValueMisc.isStoreClassId(item.authClassId)
                                ?
                                <VzmPrint label={InputMap.storeName.label} value={item.storeName} />
                                :
                                <VzmPrint label={InputMap.dcName.label} value={item.dcName} />
                            }
                        </Grid>

                        <Grid item xs={2}>
                            <VzmPrint label={InputMap.zipCd.label} value={item.zipCd} />
                        </Grid>
                        <Grid item xs={10}>
                            <VzmPrint label={InputMap.addr.label} value={item.addr} />
                        </Grid>

                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.telno.label} value={item.telno} />
                        </Grid>
                        <Grid item xs={8}></Grid>
                        <Grid item xs={12}>
                            <VzmPrint label={InputMap.email.label} value={item.email} />
                        </Grid>

                        {/* <Grid item xs={4}>
                            <VzmPrint label={InputMap.dcCd.label} value={item.dcCd} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.storeId.label} value={item.storeId} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.comId.label} value={item.comId} />
                        </Grid> */}
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.allocType.label} value={item.allocType} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.allocFlagLabel.label} value={item.allocFlagLabel} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.allocDate.label} value={item.allocDate} />
                        </Grid>
                        
                        <Grid item xs={12}>
                            <VzmCheckbox
                                dict={PermitMap.permit}
                                value={input.data.permit}
                                onChange={onChangeValue}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <VzmTextField
                                dict={PermitMap.note}
                                value={input.data.note}
                                onChange={onChangeValue}
                                fullWidth={true}
                            />
                        </Grid>
                    </Grid>
                </ViewContainer>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClickPermit}
                    variant={AppStyle.mui.contained}
                    color={AppStyle.mui.primary}
                    disabled={
                        input.hasError
                        || !canPermit
                    }
                    sx={{width: 120, marginRight: 1}}
                    startIcon={<VerifiedUserIcon />}
                >
                    {input.data.permit?'승인확정':'불허확정'}
                </Button>
                <Button onClick={onClose}
                    variant={AppStyle.mui.contained}
                    color={AppStyle.mui.primary}
                    sx={{width: 120}}
                    startIcon={<DoneIcon />}
                >
                    닫기
                </Button>
            </DialogActions>
        </DraggableViewer>
    );

}